import React, { useEffect, useState } from 'react';

const PdfViewer = ({ selectedFileUrl, fileName }) => {
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        if (selectedFileUrl) {
            setLoading(true);
            // Reset loading state when a new file is loaded
            const timer = setTimeout(() => setLoading(false), 500);
            return () => clearTimeout(timer);
        }
    }, [selectedFileUrl]);

    return (
        <div className="bg-white rounded flex-1 h-auto">
            {loading ? (
                <div className="flex justify-center items-center h-96 bg-gray-50">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                </div>
            ) : (
                <iframe
                    src={selectedFileUrl}
                    className="w-full h-full border-none"
                    title="PDF Viewer"
                    onLoad={() => setLoading(false)}
                />
            )}
        </div>
    );
};

export default PdfViewer;